import React from 'react';
import './LearningHub.css';

export default function LearningHub() {
  return (
    <section className="learning-hub-section section-padding" id="learning-hub">
      <div className="container learning-hub-container">
        <div className="learning-grid">
          {/* Left Column: Heading */}
          <div className="learning-content">
            <div className="learning-badge">
              <span className="learning-brand">Haatza</span>
              <span className="learning-divider">|</span>
              <div className="learning-badge-stacked">
                <span className="badge-seller">Seller</span>
                <span className="badge-learninghub"><span className="badge-learning-bold">Learning</span>Hub</span>
              </div>
            </div>
            <h2 className="learning-title">
  <span className="title-line1">Learn how to sell and grow your</span>
  <span className="title-line2">business on <span className="title-highlight">Haatza</span></span>
</h2>
          </div>

          {/* Right Column: Embedded YouTube Video */}
          <div className="learning-video-panel">
            <div className="video-iframe-wrapper">
              <iframe
                src="https://www.youtube.com/embed/a6tEKsom-dA"
                title="Learn how to sell on Haatza"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="learning-iframe"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
